import React, { useEffect, useState } from 'react'
import { Button, Grid, TextField, FormControl } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { Tooltip, Typography } from '@material-ui/core'
import { useTheme } from '@material-ui/core/styles'
import { NavLink } from 'react-router-dom'
import MoreHorizIcon from '@material-ui/icons/MoreHoriz'
import { retrievePageFields } from '../shared/Views'
import { updateShipment } from '../../api/api'
import { IconButton } from '@material-ui/core'
import SaveIcon from '@material-ui/icons/Save'
import { LinearProgress } from '@material-ui/core'
import CancelIcon from '@material-ui/icons/Cancel'
import DialogOk from '../shared/DialogOk'

const classes = makeStyles(theme => ({}))

export default function ShipmentDetailCard({
    item,
    itemextra,
    shippersRefLabel,
    shippersRef,
    ownerRef,
    orderRef,
    quantity,
    volumeLabel,
    volume,
    weight,
    organization,
    clientId,
    showOrders,
    showShippersRef = true,
    showOwnersRef = true,
    transactiontype
}) {
    const [pageFields, setPageFields] = useState(null)
    const [hasChanges, setHasChanges] = useState(false)
    const [updatedShipment, setUpdatedShipment] = useState({
        ownersReference: ownerRef,
        shipmentNumber: null,
        customsNumber: item.shipmentNumber
    })
    const [updateAlert, setUpdateAlert] = useState({
        open: false,
        message: '',
        severity: 'success'
    })
    const [updatingShipment, setUpdatingShipment] = useState(false)
    const [originalOwnerRef, setOriginalOwnerRef] = useState(ownerRef)

    useEffect(() => {
        retrievePageFields('shipmentdetail', clientId).then(response => {
            setPageFields(response)
        })
    }, [])

    const theme = useTheme()

    const renderNavLinkOrderRef = (clientId, shipmentData) => {
        var orderRefs = shipmentData.orderReferenceNumber
        if (orderRefs) {
            return (
                <>
                    {orderRefs.split(',').map((refnum, index) => {
                        if (shipmentData.orders) {
                            var order = shipmentData.orders.find(
                                order => order.orderNumber === refnum.trim()
                            )
                            if (order) {
                                return showOrders ? (
                                    <NavLink
                                        key={index}
                                        to={
                                            '/orders/' +
                                            clientId +
                                            '/' +
                                            btoa(refnum.trim()).replace(
                                                '/',
                                                '_'
                                            ) +
                                            '/' +
                                            order.orderNumberSplit
                                        }
                                    >
                                        {refnum}
                                    </NavLink>
                                ) : (
                                    <span>{refnum}</span>
                                )
                            } else {
                                return <span>{refnum}</span>
                            }
                        } else {
                            return <span>{refnum}</span>
                        }
                    })}
                </>
            )
        } else {
            return <>-</>
        }
    }

    const handleUpdateShipmentSuccess = () => {
        setUpdateAlert({
            open: true,
            message: 'Shipment updated successfully',
            severity: 'success'
        })
        setHasChanges(false)
        setUpdatingShipment(false)
    }

    const handleUpdateShipmentError = (error) => {
        setUpdateAlert({
            open: true,
            message: error,
            severity: 'error'
        })
        setUpdatingShipment(false)
    }

    const editField = field => {
        if (pageFields) {
            const requiredField = pageFields.find(
                pageField => pageField.field === field
            )
            if (requiredField) {
                return requiredField.editable
            }
        }
        return false
    }

    const handleChange = e => {
        setUpdatedShipment({
            ...updatedShipment,
            ownersReference: e.target.value
        })
        if (e.target.value !== originalOwnerRef) {
            setHasChanges(true)
        } else {
            setHasChanges(false)
        }
    }

    const renderOwnersRef = () => {

        // check if field exists in pageFields
        if (editField('details.ownerref')) {
            return (
                <TextField
                    id="ownerRef"
                    name="ownerRef"
                    value={updatedShipment.ownersReference}
                    variant="outlined"
                    style={{
                        width: '80%'
                    }}
                    size="small"
                    disabled={updatingShipment}
                    onChange={e => {
                        handleChange(e)
                    }}
                />
            )
        } else {
            return (
                <p className="mb-0 font-14  font-nutosans-bold text-black">
                    {(item !== null && ownerRef) || '-'}
                </p>
            )
        }             
    }

    const handleShipmentSave = () => {
        setUpdatingShipment(true)
        updateShipment(updatedShipment, handleUpdateShipmentSuccess, handleUpdateShipmentError)
    }
    
    const handleCancel = () => {
        setUpdatedShipment({
            ownersReference: originalOwnerRef,
            shipmentNumber: null,
            customsNumber: item.shipmentNumber
        })
        setHasChanges(false)
    }

    const renderToolTipOrderRef = orderRef => {
        var orderRefs = ''
        var array = []
        if (item !== null && orderRef != null) {
            array = orderRef.split(',')
            if (array.length <= 2) {
                orderRefs = array.join()
            } else {
                orderRefs = array[0]
            }
        }

        return (
            <>
                {orderRefs}
                {array.length > 2 ? (
                    <Tooltip
                        title={
                            <React.Fragment>
                                <p>{array.join()}</p>
                            </React.Fragment>
                        }
                        placement="right"
                    >
                        <MoreHorizIcon />
                    </Tooltip>
                ) : (
                    ''
                )}
            </>
        )
    }

    return (
        <div className="p-0 pl-3">
            <h5 className="text-Curious-blue my-2 font-14">
                {transactiontype} Details
            </h5>
            <Grid
                container
                direction="row"
                spacing={1}
                className={theme.bgColorSection}
            >
                <Grid item xs={12}>
                    <Grid container direction="row" spacing={1}>
                        <Grid item xs={4} className="sm-flex-100">
                            <div>
                                <Typography
                                    variant="h6"
                                    gutterBottom
                                    className="font-12 font-raleway-medium text-lviv-blue"
                                >
                                    Weight
                                </Typography>
                                <p className="mb-0 font-14  font-nutosans-bold text-black">
                                    {' '}
                                    {(item !== null && weight) || '-'}
                                </p>
                            </div>
                        </Grid>
                        <Grid item xs={4} className="sm-flex-100">
                            <div>
                                <Typography
                                    variant="h6"
                                    gutterBottom
                                    className="font-12 font-raleway-medium text-lviv-blue"
                                >
                                    {volumeLabel}
                                </Typography>
                                <p className="mb-0 font-14  font-nutosans-bold text-black">
                                    {' '}
                                    {(item !== null && volume) || '-'}
                                </p>
                            </div>
                        </Grid>
                        <Grid item xs={4} className="sm-flex-100">
                            <div>
                                <Typography
                                    variant="h6"
                                    gutterBottom
                                    className="font-12 font-raleway-medium text-lviv-blue"
                                >
                                    Quantity
                                </Typography>
                                <p className="mb-0 font-14  font-nutosans-bold text-black">
                                    {' '}
                                    {(itemextra !== null &&
                                        itemextra.quantity) ||
                                        '-'}
                                </p>
                            </div>
                        </Grid>
                        {showShippersRef && (
                            <Grid item xs={4} className="sm-flex-100">
                                <div>
                                    <Typography
                                        variant="h6"
                                        gutterBottom
                                        className="font-12 font-raleway-medium text-lviv-blue"
                                    >
                                        {shippersRefLabel}
                                    </Typography>
                                    <p className="mb-0 font-14  font-nutosans-bold text-black">
                                        {' '}
                                        {(item !== null && shippersRef) || '-'}
                                    </p>
                                </div>
                            </Grid>
                        )}
                        <Grid
                            item
                            xs={4}
                            hidden={
                                organization !== null &&
                                organization.shipmentServiceSelected ==
                                    'NORMANHK'
                            }
                            className="sm-flex-100"
                        >
                            <div>
                                <Typography
                                    variant="h6"
                                    gutterBottom
                                    className="font-12 font-raleway-medium text-lviv-blue"
                                >
                                    Linked Order #
                                </Typography>
                                <p className="mb-0 font-14  font-nutosans-bold text-black">
                                    {renderNavLinkOrderRef(clientId, item)}
                                </p>
                            </div>
                        </Grid>
                        {showOwnersRef ? (
                                <Grid
                                    item
                                    xs={3}
                                    className="sm-flex-100"
                                >
                                    <div>
                                        <Typography
                                            variant="h6"
                                            gutterBottom
                                            className="font-12 font-raleway-medium text-lviv-blue"
                                        >
                                            Owner's Ref #
                                        </Typography>
                                        {renderOwnersRef()}
                                    </div>
                                </Grid>
                            ) : (
                                <Grid item xs={3} className="sm-flex-100" />
                            )}
                        <Grid item xs={1} className="sm-flex-100" />
                        <Grid item xs={4} className="sm-flex-100">
                            <div>
                                <Typography
                                    variant="h6"
                                    gutterBottom
                                    className="font-12 font-raleway-medium text-lviv-blue"
                                >
                                    Order's Ref#
                                </Typography>
                                <p className="mb-0 font-14  font-nutosans-bold text-black">
                                    {' '}
                                    {orderRef
                                        ? renderToolTipOrderRef(orderRef)
                                        : '-'}
                                </p>
                            </div>
                        </Grid>
                        <Grid item xs={8} className="sm-flex-100">
                            <div>
                                <Typography
                                    variant="h6"
                                    gutterBottom
                                    className="font-12 font-raleway-medium text-lviv-blue"
                                >
                                    {' '}
                                    Description{' '}
                                </Typography>
                                <p className="mb-0 font-14  font-nutosans-bold text-black">
                                    {' '}
                                    {(item !== null && item.goodsDescription) ||
                                        '-'}
                                </p>
                            </div>
                        </Grid>
                        <Grid item xs={6} className="sm-flex-100" />
                        {
                            hasChanges && (
                                <>
                                    <Grid item xs={3}>
                                        <Button
                                            variant="outlined"
                                            color="primary"
                                            fullWidth
                                            disabled={updatingShipment}
                                            onClick={() => {
                                                handleCancel()
                                            }}
                                            startIcon={<CancelIcon />}
                                        >
                                            Cancel
                                        </Button>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            fullWidth
                                            disabled={updatingShipment}
                                            onClick={() => {
                                                handleShipmentSave()
                                            }}
                                            startIcon={<SaveIcon />}
                                        >
                                            Save
                                        </Button>
                                    </Grid>
                                </>
                            )
                        }
                    </Grid>
                </Grid>
            </Grid>
            {updatingShipment && <LinearProgress />}
            <DialogOk
                show={updateAlert.open}
                title={updateAlert.severity === 'success' ? 'Shipment Updated' : 'Shipment Update Error'}
                callback={() => setUpdateAlert({ ...updateAlert, open: false })}
            >
                {updateAlert.message}
            </DialogOk>
        </div>
    )
}
